const { factory } = require( './HistoryResultsFactory' )

exports.ResultsFactory = factory
